import globalSettings from "../json/settings"
import Immutable from "immutable"

var immutableSettings = Immutable.fromJS(globalSettings)
const settings = (state = immutableSettings, action) => {
    switch (action.type) {
        case 'FILTER_SETTINGS_LIST':
            return immutableSettings.map((k =>
                    k.filter((k2, v2) => v2.toUpperCase().includes(action.filterString.toUpperCase()))
                ))
        case 'CHANGE_GLOBAL_SETTING':
            return state.setIn([action.optionName, "value"], parseInt(action.optionValue))

        case 'LOAD_SETTINGS':
            var temp = state;
            state.keySeq().forEach(k => {
                if (action.settings.get(k) !== undefined) {
                    temp = temp.set(k, action.settings.get(k));
                }
            })
            return temp;
        default:
            return state;
    }
}
export default settings

